import "./whatsapp.css";
import whats_app from "../../assets/whatsapp.png";

function Whatsapp() {
  return (
    // <!-- start whatsapp_massenger  -->
    <div className="whatsapp">
      <a
        href="https://api.whatsapp.com/send?phone=201143837483"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src={whats_app} alt="" />
      </a>
    </div>
  );
}

export default Whatsapp;
